import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { HideScrollbar } from '../../global/commonStyle';

const Group = styled.div`
  display: flex;
  overflow: hidden;
  height: 100dvh;
`;

const LeftDiv = styled.div`
  width: 100%;
  max-width: 306px;
  ${HideScrollbar}
  border-right: 0.5px solid var(--border-primary);
  background-color: var(--background-navbar);
  ${mobile_xl(css`
    max-width: 100%;
    border-right: none;
    overflow: unset;
  `)}
`;

const RightDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: var(--space-0) auto;
  overflow: hidden;
`;
export { Group, RightDiv, LeftDiv };
